import { Observable } from 'rxjs';

import { createProviderToken, TypedProvider } from '@core/common-legacy';
import { ReportDashboardMetricOptions, ReportsTranslations } from '@core/reports-types';

const { inject: injectReportsTranslations, provide } =
  createProviderToken<ReportsTranslations>('ReportsTranslations')();

const { inject: injectReportsMetrics, provide: provideReportsMetrics } =
  createProviderToken<Observable<ReportDashboardMetricOptions[]>>('ReportsMetrics')();

const provideReportsTranslations = ({
  translations,
  metrics,
}: {
  translations: TypedProvider<ReportsTranslations>;
  metrics: TypedProvider<Observable<ReportDashboardMetricOptions[]>>;
}) => [provideReportsMetrics(metrics), provide(translations)];

export { provideReportsTranslations, injectReportsTranslations, injectReportsMetrics };
